import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    gridAutoCardLoad: {
      margin: 3,
      height: 230,
      alignItems: 'center',
      justifyContent: 'center',
    },
    gridAutoCard: {
      margin: 3,
      height: 230,
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    gridAutoCardModal: {
      margin: 3,
      height: 230,
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    gridAutoCardModalManyItems: {
      margin: 3,
      height: 230,
      alignItems: 'start',
      justifyContent: 'space-between',
    },
    graphLegendsContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    detailsButton: {
      borderColor: palette.navCompanyContextActions,
      color: palette.navCompanyContextActions,
      width: '100%',
      padding: 1,
      marginLeft: 11,
    },
    displayFlex: { display: 'flex', alignItems: 'center', marginLeft: 8 },
    iconGrid: {
      margin: '8px 16px 8px 0',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    avatar: {
      cursor: 'pointer',
      width: 24,
      height: 24,
    },
    avatarCompanyContext: {
      backgroundColor: palette.lightNavCompanyContextActions,
      color: palette.navCompanyContextActions,
    },
    avatarAdmin: {
      backgroundColor: palette.lightNavAdminActions,
      color: palette.navAdminActions,
    },
    avatarSuperAdmin: {
      backgroundColor: palette.lightNavSuperAdminActions,
      color: palette.navSuperAdminActions,
    },
    avatarOperator: {
      backgroundColor: palette.lightNavOperatorActions,
      color: palette.navOperator,
    },
    icon: { fontSize: 22 },
    infoIcon: {
      fontSize: 15,
      color: palette.gray,
    },
    legendManyItems: {
      display: 'flex',
      overflowY: 'scroll',
      flexDirection: 'column',
      maxHeight: 230,
    },
    seeMoreButton: { padding: '0px 12px', justifyContent: 'flex-start' },
  });

export const overrideCardDoughnut = {
  minHeight: 0,
  '&:after': {
    visibility: 'hidden',
  },
  '&:before': {
    visibility: 'hidden',
  },
};

export const overrideModalStatus = {
  content: {
    padding: 12,
    fontSize: '12px !important',
    height: 550,
    width: 800,
    overflowX: 'auto',
  },
};
